/** @jsx jsx */

import React, { Fragment as _, memo, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column } from '@chameleoncreator/creator-ui';
import Image from 'components/lib/Image';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Container from 'components/Layouts/ContainerLogical';
import Multichoice_v2 from './Multichoice_v2';
import Media, { MediaContext, IMediaContext } from 'components/lib/Media';
import { imgPlaceholders } from 'components/lib/Image';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import SVG from 'components/lib/SVG';
import Embed from 'components/lib/Embed';
import Answer from './Answer';
import { Block } from '@chameleoncreator/creator-app';
import getBlockById from 'services/apiHelpers/getBlockById';
import EditableBtn from 'components/lib/EditableBtn';
import shouldUpdate from 'services/shouldUpdate';
import PDF from 'components/lib/PDF';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';
import { interactionContext as InteractionContext } from './interactionContext';
import MultiChoice_default from 'assets/Rectangle.png';
import CC_QuestionTextImage from 'assets/CC_Question Text + Image.svg';
import { ImageContext } from 'components/lib/Image/Image';
import { findByKeyVal_V2 } from 'services/findByKeyVal';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  ColumnContentForMultichoiceMedia: ({ children, ...props }) => {
    const interactionContext = useContext(InteractionContext);

    const { includeQuestionTextPlusImage } = interactionContext.props;

    const [img, txt] = children;

    return includeQuestionTextPlusImage ? (
      <ImageContext.Provider
        value={{
          placeholder: CC_QuestionTextImage,
        }}
      >
        {img}
      </ImageContext.Provider>
    ) : (
      <span id={`multichoice-media-question-text-${interactionContext.id}`}>
        {txt}
      </span>
    );
  },
  InteractionColumn: ({ children, ...props }) => {
    const interactionContext = useContext(InteractionContext);
    const { includeAdditionalTextField } = interactionContext.props;

    const [multichoice, txt] = children;

    if (!includeAdditionalTextField) {
      return multichoice;
    }

    return (
      <_>
        {multichoice}
        <div
          style={{
            margin: '20px 0 0 0',
          }}
        >
          {txt}
        </div>
      </_>
    );
  },
  Text: EditableText,

  Image: ({ children, ...props }) => {
    const mediaContext = useContext(MediaContext) as IMediaContext;
    const { isAdditionalMedia } = mediaContext;

    return (
      <Image
        {...{
          ...props,
          placeholder: imgPlaceholders[1],
        }}
      />
    );
  },
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton: EditableBtn,
  ReviewFeedback: EditableBtn,
  Video,
  Audio,
  Transcript: ({ children, props }) => {
    return children;
  },
  SVG,
  Embed,
  Media,
  MultichoiceMedia: ({ children, props }) => children,
  MultichoiceWithText: Multichoice_v2,
  //
  Answer,
  Feedback: () => null,
  Correct: () => null,
  Incorrect: () => null,
  Attempt: () => null,
  PDF,
  OpenPDF,
  Modal: () => null,
};

const MultichoiceDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  const hasAttemptFeedback = findByKeyVal_V2(
    interactionBlock.id,
    'type',
    'Attempt'
  );

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <InteractionContext.Provider
        value={{
          ...interactionBlock,
          updateItemsSeen: null,
          hasAttemptFeedback,
        }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </InteractionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default MultichoiceDisplay;
